import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../_services/authentication/authentication.service';
import { SessionService } from '../../../_services/session/session.service';
import { BaseComponent } from '../../../components/base/base.component';

@Component({
  standalone: true,
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.scss'],
})
export class RedirectComponent extends BaseComponent implements OnInit {
  constructor(
    private router: Router,
    public session: SessionService,
    private authenticationService: AuthenticationService
  ) {
    super(session);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.authenticationService.loadContext().subscribe({
      next: (context: any) => {
        const permissions = context?.customers || this.session.getPermissions();
        const isSuperUser = this.isSuperUser();

        if (permissions.length === 1 && !isSuperUser) {
          const customer = permissions[0];
          this.router.navigate([
            'administration',
            customer.identifier || customer.id,
            'users',
          ]);
          return;
        }

        this.router.navigate(['administration', 'customers']);
      },
      error: () => {
        this.router.navigate(['administration', 'customers']);
      },
    });
  }
}
